<template>
  <div>
    <!-- 车辆管理  -->
    <a-modal
        :title="title"
        :visible="visible"
        :footer="null"
        @cancel="cancelBtn"
        width="1000px"
    >
      <div class="ConferenceHotel">
        <div style="font-weight: normal">
          <a-button @click="openModel" type="primary" style="margin:0 0 20px 0">+ 新增</a-button>
          <a-table :columns="columns" :data-source="data" :pagination="false">
          <span slot="serialNumber" slot-scope="text, record, index">
            {{index+1}}
          </span>
            <span slot="action" slot-scope="text, record">
            <a @click="editBtn(record)" style="margin-right: 10px">修改</a>
            <a-popconfirm
                title="是否确认删除?"
                ok-text="是"
                cancel-text="否"
                @confirm="hotelDel(record.id)"
            ><a href="#">删除</a></a-popconfirm>
          </span>
          </a-table>
          <!--        <div class="pagination">-->
          <!--          <a-pagination show-quick-jumper :default-current="current" :total="total" @change="onChange" />-->
          <!--        </div>-->
        </div>
      </div>
    </a-modal>

    <a-modal
        :title="titleModel"
        :visible="visibleModel"
        @ok="okModelBtn"
        @cancel="cancelModelBtn"
        width="400px"
    >
      <a-form-model
          ref="ruleFormModel"
          :model="formModel"
          :rules="rulesModel"
          :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="司机名称" prop="name">
              <a-input v-model="formModel.name" placeholder="请输入" style="width: 230px"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="联系电话" prop="contactsTel">
              <a-input v-model="formModel.contactsTel" placeholder="请输入" style="width: 230px"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="所属公司" prop="company">
              <a-input v-model="formModel.company" placeholder="请输入" style="width: 230px"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="车牌号" prop="carNumber">
              <a-input v-model="formModel.carNumber" placeholder="请输入" style="width: 230px"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="车辆信息" prop="carInfo">
              <a-input v-model="formModel.carInfo" placeholder="请输入" style="width: 230px"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  delCar,
  getCar,
  postCar,
  putCar,
} from "@/service/hotelManageApi";

export default {
  name: "HotelManagement",
  props:{
    visible:{
      type:Boolean,
    },
    title:{
      type:String
    },
    conventionCode:{
      type:String
    },
  },
  data(){
    return{
      columns:[
        {
          title: '司机名称',
          dataIndex: 'name',
          key: 'name',
          width:'20%',
        },
        {
          title: '联系电话',
          dataIndex: 'contactsTel',
          key: 'contactsTel',
          width:'15%',
        },
        {
          title: '所属公司',
          key: 'company',
          dataIndex: 'company',
          width:'20%',
        },
        {
          title: '车牌号',
          key: 'carNumber',
          dataIndex: 'carNumber',
          width:'10%',
        },
        {
          title: '车辆信息',
          key: 'carInfo',
          dataIndex: 'carInfo',
          width:'20%',
        },
        {
          title: '操作',
          key: 'action',
          width:'15%',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data:[],
      total:0,
      current:1,

      visibleModel:false,
      formModel:{},
      rulesModel:{
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        contactsTel: [{ required: true, message: '请输入', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }],
        company: [{ required: true, message: '请输入', trigger: 'blur' }],
        carNumber: [{ required: true, message: '请输入', trigger: 'blur' }],
        carInfo: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      titleModel:'',
    }
  },
  created() {
    this.hotelGet();
  },
  methods:{
    // 获取本次会议住宿酒店
    async hotelGet() {
      const res = await getCar(this.conventionCode)
      if(res.code === 200){
        this.data = res.data;
      }else {
        this.$message.warning(res.message)
      }
    },

    // 新增住宿酒店
    async hotelPost(data) {
      const res = await postCar(data)
      if(res.code === 200){
        this.$message.success("新增成功！");
        await this.hotelGet();
        this.cancelModelBtn();
      }else {
        this.$message.warning(res.message)
      }
    },

    // 修改住宿酒店
    async hotelPut(data) {
      const res = await putCar(data)
      if(res.code === 200){
        this.$message.success("修改成功！");
        await this.hotelGet();
        this.cancelModelBtn();
      }else {
        this.$message.warning(res.message)
      }
    },


    // 删除住宿酒店
    async hotelDel(id) {
      let data = {
        id:id
      }
      const res = await delCar(data)
      if(res.code === 200){
        this.$message.success("删除成功！");
        await this.hotelGet();
      }else {
        this.$message.warning(res.message)
      }
    },
    cancelBtn(){
      let flag = false;
      this.$emit("closeMain", flag); //子组件向父组件传值(开关)
    },
    onChange(page,pageSize){
      this.current = page;
    },
    editBtn(row){
      this.formModel = {
        id:row.id,
        name: row.name,
        contactsTel: row.contactsTel,
        company: row.company,
        carNumber: row.carNumber,
        carInfo: row.carInfo,
      }
      this.titleModel = '修改';
      this.formModel.conventionCode = this.conventionCode;
      this.visibleModel = true;
    },
    cancelModelBtn(){
      this.visibleModel = false;
      this.$refs.ruleFormModel.resetFields();
      this.formModel = {
        name: '',
        contactsTel: '',
        company: '',
        carNumber: '',
        carInfo: '',
      }
    },
    okModelBtn(){
      this.$refs.ruleFormModel.validate(valid => {
        if (valid) {
          this.formModel.conventionCode = this.conventionCode;
          if(this.titleModel === '新增'){
            this.hotelPost(this.formModel)
          }else if(this.titleModel === '修改'){
            this.hotelPut(this.formModel)
          }

        } else {
          return false;
        }
      });
    },
    openModel(){
      this.titleModel = '新增';
      this.visibleModel = true;
    },
  }
}
</script>

<style scoped lang="scss">
.ConferenceHotel{
  font-weight: bold;
  min-height: 500px;
  color: #333333;
}
.ConferenceHotel-form{
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}
.pagination{
  width: 100%;
  display: flex;
  justify-content: right;
  margin-top: 10px;
}
</style>
